import { render, staticRenderFns } from "./PCardShowHiden.vue?vue&type=template&id=2d1de2c2&scoped=true&"
import script from "./PCardShowHiden.vue?vue&type=script&lang=ts&"
export * from "./PCardShowHiden.vue?vue&type=script&lang=ts&"
import style0 from "./PCardShowHiden.vue?vue&type=style&index=0&id=2d1de2c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1de2c2",
  null
  
)

export default component.exports